<template>
    <div id="report">
        <h6 class="page-title">Assessment Report / Retention Priority</h6>
        <div class="select-priority">
            <div class="text-right mb-4">
            </div>
            <div>
                <p class="mb-5">Review assessment findings for each of the five retention priority areas, and then select your dealership’s top improvement priority using the dropdown below. Once a priority is chosen, review the suggested practices to implement and select which ones to add to the dealership’s Action Plan.</p>
            </div>
          <div class="row">

            <div class="col-md-6">
              <h6 class="select-priority-heading">Select this Dealership’s Top Retention Priority</h6>
              <v-select class="dealership-priority" v-model="selectedPriority" :options="priority" placeholder="Select a Priority"></v-select>
            </div>
            <div class="col-md-6">
              <b-button class="action-plan-btn float-right fixed" pill @click="submitForm" :disabled="!canSubmit()">Continue to Action Plan
                <font-awesome-icon class="fa-fw" :icon="['far', 'chevron-right']"/>
              </b-button>
            </div>
          </div>
        </div>
        <div class="mt-5" v-if="assessment && ready">
<!--            <h4 class="tab-main-title">BENCHMARKS</h4>-->
<!--            <mq-layout mq="lg+">-->
          <div>
                <b-tabs fill>
                    <b-tab title="Compensation" :active="selectedPriority === 'Compensation' || selectedPriority === null">
                        <template v-slot:title>
                            <span v-show="selectedPriority === 'Compensation'" class="selected-priority">Selected Priority</span>
                            Compensation
                        </template>
                        <b-card-text class="text-left">
                            <div class="row">
                              <report-column column-width="4" name="Annual Income" :rating="ratingFromAssessment('assessmentForm.compensation.c1')">
                                <b-form-checkbox-group
                                    stacked
                                    size="lg"
                                    v-model="reportChecked.compensation.c1"
                                    :disabled="selectedPriority !== 'Compensation'"
                                >
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.compensation.c1'].some(r=> [
                                          'assessmentForm.compensation.c1.q2',
                                          'assessmentForm.compensation.c1.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.compensation.c1'].includes('assessmentForm.compensation.c1.q1')"
                                      value="q1"><span>Understand the competitive pay in your area</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.compensation.c1'].some(r=> [
                                          'assessmentForm.compensation.c1.q1',
                                          'assessmentForm.compensation.c1.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.compensation.c1'].includes('assessmentForm.compensation.c1.q2')"
                                      value="q2">
                                    <span>Take a pulse of Technician pay satisfaction</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.compensation.c1'].some(r=> [
                                          'assessmentForm.compensation.c1.q1',
                                          'assessmentForm.compensation.c1.q2',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.compensation.c1'].includes('assessmentForm.compensation.c1.q3')"
                                      value="q3"><span>Conduct a Business Case to assess trade-off costs of raises</span></b-form-checkbox>
                                </b-form-checkbox-group>
                              </report-column>
                              <report-column column-width="4" name="Pay Plan Methodology and Bonus Structure" :rating="ratingFromAssessment('assessmentForm.compensation.c2')">
                                <b-form-checkbox-group
                                    stacked
                                    size="lg"
                                    v-model="reportChecked.compensation.c2"
                                    :disabled="selectedPriority !== 'Compensation'"
                                >
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.compensation.c2'].some(r=> [
                                          'assessmentForm.compensation.c2.q2',
                                          'assessmentForm.compensation.c2.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.compensation.c2'].includes('assessmentForm.compensation.c2.q1')"
                                      value="q1"><span>Institute guaranteed minimums for apprentices or new hires and production bonuses</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.compensation.c2'].some(r=> [
                                          'assessmentForm.compensation.c2.q1',
                                          'assessmentForm.compensation.c2.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.compensation.c2'].includes('assessmentForm.compensation.c2.q2')"
                                      value="q2">
                                    <span>Compensate technicians for common pain points.</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.compensation.c2'].some(r=> [
                                          'assessmentForm.compensation.c2.q1',
                                          'assessmentForm.compensation.c2.q2',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.compensation.c2'].includes('assessmentForm.compensation.c2.q3')"
                                      value="q3"><span>Establish an hourly bank</span></b-form-checkbox>
                                </b-form-checkbox-group>
                              </report-column>
                              <report-column column-width="4" name="Benefits" :rating="ratingFromAssessment('assessmentForm.compensation.c3')">
                                <b-form-checkbox-group
                                    stacked
                                    size="lg"
                                    v-model="reportChecked.compensation.c3"
                                    :disabled="selectedPriority !== 'Compensation'"
                                >
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.compensation.c3'].some(r=> [
                                          'assessmentForm.compensation.c3.q2',
                                          'assessmentForm.compensation.c3.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.compensation.c3'].includes('assessmentForm.compensation.c3.q1')"
                                      value="q1"><span>Individual healthcare coverage and 2% 401(k) match</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.compensation.c3'].some(r=> [
                                          'assessmentForm.compensation.c3.q1',
                                          'assessmentForm.compensation.c3.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.compensation.c3'].includes('assessmentForm.compensation.c3.q2')"
                                      value="q2">
                                    <span>Family healthcare coverage, 3%-5% 401(k) match, financial education and higher PTO starting rates</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.compensation.c3'].some(r=> [
                                          'assessmentForm.compensation.c3.q1',
                                          'assessmentForm.compensation.c3.q2',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.compensation.c3'].includes('assessmentForm.compensation.c3.q3')"
                                      value="q3"><span>Tool and tuition incentive programs</span></b-form-checkbox>
                                </b-form-checkbox-group>
                              </report-column>
                            </div>

                        </b-card-text>
                    </b-tab>
                    <b-tab title="Training" :active="selectedPriority === 'Training'">
                        <template v-slot:title>
                            <span v-show="selectedPriority === 'Training'" class="selected-priority">Selected Priority</span>
                            Training
                        </template>
                        <b-card-text class="text-left">
                            <div class="row">
                              <report-column column-width="3" name="Onboarding Process" :rating="ratingFromAssessment('assessmentForm.training.c1')">
                                <b-form-checkbox-group
                                    stacked
                                    size="lg"
                                    v-model="reportChecked.training.c1"
                                    :disabled="selectedPriority !== 'Training'"
                                >
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.training.c1'].some(r=> [
                                          'assessmentForm.training.c1.q2',
                                          'assessmentForm.training.c1.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.training.c1'].includes('assessmentForm.training.c1.q1')"
                                      value="q1"><span>Onboard new Technicians with a dealership tour and review of basic expectations</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.training.c1'].some(r=> [
                                          'assessmentForm.training.c1.q1',
                                          'assessmentForm.training.c1.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.training.c1'].includes('assessmentForm.training.c1.q2')"
                                      value="q2">
                                    <span>Formally introduce new hires to staff Technicians and provide a social mentor</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.training.c1'].some(r=> [
                                          'assessmentForm.training.c1.q1',
                                          'assessmentForm.training.c1.q2',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.training.c1'].includes('assessmentForm.training.c1.q3')"
                                      value="q3"><span>Review documented Repair Order Processes with new technicians</span></b-form-checkbox>
                                </b-form-checkbox-group>
                              </report-column>
                              <report-column column-width="3" name="Training Class Policies" :rating="ratingFromAssessment('assessmentForm.training.c2')">
                                <b-form-checkbox-group
                                    stacked
                                    size="lg"
                                    v-model="reportChecked.training.c2"
                                    :disabled="selectedPriority !== 'Training'"
                                >
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.training.c2'].some(r=> [
                                          'assessmentForm.training.c2.q2',
                                          'assessmentForm.training.c2.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.training.c2'].includes('assessmentForm.training.c2.q1')"
                                      value="q1"><span>Once hired, promptly create a training plan for new Technicians</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.training.c2'].some(r=> [
                                          'assessmentForm.training.c2.q1',
                                          'assessmentForm.training.c2.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.training.c2'].includes('assessmentForm.training.c2.q2')"
                                      value="q2">
                                    <span>Monitor training progress and waitlist Technicians for Instructor-Led Training as soon as they are eligible</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.training.c2'].some(r=> [
                                          'assessmentForm.training.c2.q1',
                                          'assessmentForm.training.c2.q2',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.training.c2'].includes('assessmentForm.training.c2.q3')"
                                      value="q3"><span>Reimburse Technicians for lost hours and related expenses. (e.g., Travel, lodging, meals)</span></b-form-checkbox>
                                </b-form-checkbox-group>
                              </report-column>
                              <report-column column-width="3" name="Career Planning" :rating="ratingFromAssessment('assessmentForm.training.c3')">

                                <b-form-checkbox-group
                                    stacked
                                    size="lg"
                                    v-model="reportChecked.training.c3"
                                    :disabled="selectedPriority !== 'Training'"
                                >
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.training.c3'].some(r=> [
                                          'assessmentForm.training.c3.q2',
                                          'assessmentForm.training.c3.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.training.c3'].includes('assessmentForm.training.c3.q1')"
                                      value="q1"><span>Document the career path from new hire to Master Technician</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.training.c3'].some(r=> [
                                          'assessmentForm.training.c3.q1',
                                          'assessmentForm.training.c3.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.training.c3'].includes('assessmentForm.training.c3.q2')"
                                      value="q2">
                                    <span>Establish career goals and monitor path</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.training.c3'].some(r=> [
                                          'assessmentForm.training.c3.q1',
                                          'assessmentForm.training.c3.q2',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.training.c3'].includes('assessmentForm.training.c3.q3')"
                                      value="q3"><span>Reevaluate Technician goals over time</span></b-form-checkbox>
                                </b-form-checkbox-group>
                              </report-column>
                              <report-column column-width="3" name="Mentorship Programs" :rating="ratingFromAssessment('assessmentForm.training.c4')">
                                <b-form-checkbox-group
                                    stacked
                                    size="lg"
                                    v-model="reportChecked.training.c4"
                                    :disabled="selectedPriority !== 'Training'"
                                >
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.training.c4'].some(r=> [
                                          'assessmentForm.training.c4.q2',
                                          'assessmentForm.training.c4.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.training.c4'].includes('assessmentForm.training.c4.q1')"
                                      value="q1"><span>Create a defined mentorship process</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.training.c4'].some(r=> [
                                          'assessmentForm.training.c4.q1',
                                          'assessmentForm.training.c4.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.training.c4'].includes('assessmentForm.training.c4.q2')"
                                      value="q2">
                                    <span>Vet and select mentors</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.training.c4'].some(r=> [
                                          'assessmentForm.training.c4.q1',
                                          'assessmentForm.training.c4.q2',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.training.c4'].includes('assessmentForm.training.c4.q3')"
                                      value="q3"><span>Rotate mentors</span></b-form-checkbox>
                                </b-form-checkbox-group>
                              </report-column>
                            </div>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Management" :active="selectedPriority === 'Management'">
                        <template v-slot:title>
                            <span v-show="selectedPriority === 'Management'" class="selected-priority">Selected Priority</span>
                            Management
                        </template>
                        <b-card-text class="text-left">
                            <div class="row">
                              <report-column column-width="4" name="Meeting Schedule" :rating="ratingFromAssessment('assessmentForm.management.c1')">
                                <b-form-checkbox-group
                                    stacked
                                    size="lg"
                                    v-model="reportChecked.management.c1"
                                    :disabled="selectedPriority !== 'Management'"
                                >
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.management.c1'].some(r=> [
                                          'assessmentForm.management.c1.q2',
                                          'assessmentForm.management.c1.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.management.c1'].includes('assessmentForm.management.c1.q1')"
                                      value="q1"><span>Foster “like family” personal relationships and keep an open-door policy</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.management.c1'].some(r=> [
                                          'assessmentForm.management.c1.q1',
                                          'assessmentForm.management.c1.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.management.c1'].includes('assessmentForm.management.c1.q2')"
                                      value="q2">
                                    <span>Conduct morning “jump-start” meeting and monthly individual meetings</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.management.c1'].some(r=> [
                                          'assessmentForm.management.c1.q1',
                                          'assessmentForm.management.c1.q2',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.management.c1'].includes('assessmentForm.management.c1.q3')"
                                      value="q3"><span>Conduct quarterly surprise events</span></b-form-checkbox>
                                </b-form-checkbox-group>
                              </report-column>
                              <report-column column-width="4" name="Error Policy" :rating="ratingFromAssessment('assessmentForm.management.c2')">
                                <b-form-checkbox-group
                                    stacked
                                    size="lg"
                                    v-model="reportChecked.management.c2"
                                    :disabled="selectedPriority !== 'Management'"
                                >
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.management.c2'].some(r=> [
                                          'assessmentForm.management.c2.q2',
                                          'assessmentForm.management.c2.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.management.c2'].includes('assessmentForm.management.c2.q1')"
                                      value="q1"><span>Outline criteria to handle mistakes</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.management.c2'].some(r=> [
                                          'assessmentForm.management.c2.q1',
                                          'assessmentForm.management.c2.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.management.c2'].includes('assessmentForm.management.c2.q2')"
                                      value="q2">
                                    <span>Communicate criteria before problems arise</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.management.c2'].some(r=> [
                                          'assessmentForm.management.c2.q1',
                                          'assessmentForm.management.c2.q2',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.management.c2'].includes('assessmentForm.management.c2.q3')"
                                      value="q3"><span>Handle mistakes consistently</span></b-form-checkbox>
                                </b-form-checkbox-group>
                              </report-column>
                              <report-column column-width="4" name="Feedback Mechanisms" :rating="ratingFromAssessment('assessmentForm.management.c3')">
                                <b-form-checkbox-group
                                    stacked
                                    size="lg"
                                    v-model="reportChecked.management.c3"
                                    :disabled="selectedPriority !== 'Management'"
                                >
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.management.c3'].some(r=> [
                                          'assessmentForm.management.c3.q2',
                                          'assessmentForm.management.c3.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.management.c3'].includes('assessmentForm.management.c3.q1')"
                                      value="q1"><span>Conduct exit interviews</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.management.c3'].some(r=> [
                                          'assessmentForm.management.c3.q1',
                                          'assessmentForm.management.c3.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.management.c3'].includes('assessmentForm.management.c3.q2')"
                                      value="q2">
                                    <span>Conduct annual end-of-year Surveys</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.management.c3'].some(r=> [
                                          'assessmentForm.management.c3.q1',
                                          'assessmentForm.management.c3.q2',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.management.c3'].includes('assessmentForm.management.c3.q3')"
                                      value="q3"><span>Conduct quarterly feedback meetings</span></b-form-checkbox>
                                </b-form-checkbox-group>
                              </report-column>
                            </div>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Dealer Conditions" :active="selectedPriority === 'Dealer Conditions'">
                        <template v-slot:title>
                            <span v-show="selectedPriority === 'Dealer Conditions'" class="selected-priority">Selected Priority</span>
                            Dealer Conditions
                        </template>
                        <b-card-text class="text-left">
                            <div class="row">
                              <report-column column-width="3" name="Dispatch Methods" :rating="ratingFromAssessment('assessmentForm.dealerConditions.c1')">
                                <b-form-checkbox-group
                                    stacked
                                    size="lg"
                                    v-model="reportChecked.dealerConditions.c1"
                                    :disabled="selectedPriority !== 'Dealer Conditions'"
                                >
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.dealerConditions.c1'].some(r=> [
                                          'assessmentForm.dealerConditions.c1.q2',
                                          'assessmentForm.dealerConditions.c1.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.dealerConditions.c1'].includes('assessmentForm.dealerConditions.c1.q1')"
                                      value="q1"><span>Tiering of repairs</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.dealerConditions.c1'].some(r=> [
                                          'assessmentForm.dealerConditions.c1.q1',
                                          'assessmentForm.dealerConditions.c1.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.dealerConditions.c1'].includes('assessmentForm.dealerConditions.c1.q2')"
                                      value="q2">
                                    <span>Performance monitoring system</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.dealerConditions.c1'].some(r=> [
                                          'assessmentForm.dealerConditions.c1.q1',
                                          'assessmentForm.dealerConditions.c1.q2',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.dealerConditions.c1'].includes('assessmentForm.dealerConditions.c1.q3')"
                                      value="q3"><span>Dealership production bonus and 8:1 ratio</span></b-form-checkbox>
                                </b-form-checkbox-group>
                              </report-column>
                              <report-column column-width="3" name="Work Processes" :rating="ratingFromAssessment('assessmentForm.dealerConditions.c2')">
                                <b-form-checkbox-group
                                    stacked
                                    size="lg"
                                    v-model="reportChecked.dealerConditions.c2"
                                    :disabled="selectedPriority !== 'Dealer Conditions'"
                                >
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.dealerConditions.c2'].some(r=> [
                                          'assessmentForm.dealerConditions.c2.q2',
                                          'assessmentForm.dealerConditions.c2.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.dealerConditions.c2'].includes('assessmentForm.dealerConditions.c2.q1')"
                                      value="q1"><span>Understand bottleneck processes and updated tools and equipment</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.dealerConditions.c2'].some(r=> [
                                          'assessmentForm.dealerConditions.c2.q1',
                                          'assessmentForm.dealerConditions.c2.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.dealerConditions.c2'].includes('assessmentForm.dealerConditions.c2.q2')"
                                      value="q2">
                                    <span>Provide Technicians with a form of direct communication to increase time in their bay </span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.dealerConditions.c2'].some(r=> [
                                          'assessmentForm.dealerConditions.c2.q1',
                                          'assessmentForm.dealerConditions.c2.q2',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.dealerConditions.c2'].includes('assessmentForm.dealerConditions.c2.q3')"
                                      value="q3"><span>Porters or Parts Runners</span></b-form-checkbox>
                                </b-form-checkbox-group>
                              </report-column>
                              <report-column column-width="3" name="Facility Standards" :rating="ratingFromAssessment('assessmentForm.dealerConditions.c3')">
                                <b-form-checkbox-group
                                    stacked
                                    size="lg"
                                    v-model="reportChecked.dealerConditions.c3"
                                    :disabled="selectedPriority !== 'Dealer Conditions'"
                                >
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.dealerConditions.c3'].some(r=> [
                                          'assessmentForm.dealerConditions.c3.q2',
                                          'assessmentForm.dealerConditions.c3.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.dealerConditions.c3'].includes('assessmentForm.dealerConditions.c3.q1')"
                                      value="q1"><span>Dealership-supplied uniforms and standards for uniforms, cleanliness and safety</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.dealerConditions.c3'].some(r=> [
                                          'assessmentForm.dealerConditions.c3.q1',
                                          'assessmentForm.dealerConditions.c3.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.dealerConditions.c3'].includes('assessmentForm.dealerConditions.c3.q2')"
                                      value="q2">
                                    <span>Replacement uniforms and breakroom</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.dealerConditions.c3'].some(r=> [
                                          'assessmentForm.dealerConditions.c3.q1',
                                          'assessmentForm.dealerConditions.c3.q2',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.dealerConditions.c3'].includes('assessmentForm.dealerConditions.c3.q3')"
                                      value="q3"><span>Professional cleaning; laundry service; heating or air conditioning and noise tarps</span></b-form-checkbox>
                                </b-form-checkbox-group>
                              </report-column>
                              <report-column column-width="3" name="Dealership Culture" :rating="ratingFromAssessment('assessmentForm.dealerConditions.c4')">
                                <b-form-checkbox-group
                                    stacked
                                    size="lg"
                                    v-model="reportChecked.dealerConditions.c4"
                                    :disabled="selectedPriority !== 'Dealer Conditions'"
                                >
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.dealerConditions.c4'].some(r=> [
                                          'assessmentForm.dealerConditions.c4.q2',
                                          'assessmentForm.dealerConditions.c4.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.dealerConditions.c4'].includes('assessmentForm.dealerConditions.c4.q1')"
                                      value="q1"><span>Public recognition for collaboration and group outings</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.dealerConditions.c4'].some(r=> [
                                          'assessmentForm.dealerConditions.c4.q1',
                                          'assessmentForm.dealerConditions.c4.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.dealerConditions.c4'].includes('assessmentForm.dealerConditions.c4.q2')"
                                      value="q2">
                                    <span>Sporting leagues</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.dealerConditions.c4'].some(r=> [
                                          'assessmentForm.dealerConditions.c4.q1',
                                          'assessmentForm.dealerConditions.c4.q2',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.dealerConditions.c4'].includes('assessmentForm.dealerConditions.c4.q3')"
                                      value="q3"><span>Collaboration bonus</span></b-form-checkbox>
                                </b-form-checkbox-group>
                              </report-column>
                            </div>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Rewards & Recognition" :active="selectedPriority === 'Rewards & Recognition'">
                        <template v-slot:title>
                            <span v-show="selectedPriority === 'Rewards & Recognition'" class="selected-priority">Selected Priority</span>
                            Rewards & Recognition
                        </template>
                        <b-card-text class="text-left">
                            <div class="row">
                              <report-column column-width="4" name="Rewards Programs and Special Bonuses" :rating="ratingFromAssessment('assessmentForm.rewards.c1')">
                                <b-form-checkbox-group
                                    stacked
                                    size="lg"
                                    v-model="reportChecked.rewards.c1"
                                    :disabled="selectedPriority !== 'Rewards & Recognition'"
                                >
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.rewards.c1'].some(r=> [
                                          'assessmentForm.rewards.c1.q2',
                                          'assessmentForm.rewards.c1.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.rewards.c1'].includes('assessmentForm.rewards.c1.q1')"
                                      value="q1"><span>Morning meeting recognition</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.rewards.c1'].some(r=> [
                                          'assessmentForm.rewards.c1.q1',
                                          'assessmentForm.rewards.c1.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.rewards.c1'].includes('assessmentForm.rewards.c1.q2')"
                                      value="q2">
                                    <span>Employee of the Month and Daily Challenge</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.rewards.c1'].some(r=> [
                                          'assessmentForm.rewards.c1.q1',
                                          'assessmentForm.rewards.c1.q2',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.rewards.c1'].includes('assessmentForm.rewards.c1.q3')"
                                      value="q3"><span>Specialized incentives and rewards</span></b-form-checkbox>
                                </b-form-checkbox-group>
                              </report-column>
                              <report-column column-width="4" name="Workday Perks" :rating="ratingFromAssessment('assessmentForm.rewards.c2')">
                                <b-form-checkbox-group
                                    stacked
                                    size="lg"
                                    v-model="reportChecked.rewards.c2"
                                    :disabled="selectedPriority !== 'Rewards & Recognition'"
                                >
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.rewards.c2'].some(r=> [
                                          'assessmentForm.rewards.c2.q2',
                                          'assessmentForm.rewards.c2.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.rewards.c2'].includes('assessmentForm.rewards.c2.q1')"
                                      value="q1"><span>Birthdays</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.rewards.c2'].some(r=> [
                                          'assessmentForm.rewards.c2.q1',
                                          'assessmentForm.rewards.c2.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.rewards.c2'].includes('assessmentForm.rewards.c2.q2')"
                                      value="q2">
                                    <span>Coffee bar</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.rewards.c2'].some(r=> [
                                          'assessmentForm.rewards.c2.q1',
                                          'assessmentForm.rewards.c2.q2',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.rewards.c2'].includes('assessmentForm.rewards.c2.q3')"
                                      value="q3"><span>Weekend lunches</span></b-form-checkbox>
                                </b-form-checkbox-group>
                              </report-column>
                              <report-column column-width="4" name="Tenure Benefits" :rating="ratingFromAssessment('assessmentForm.rewards.c3')">
                                <b-form-checkbox-group
                                    stacked
                                    size="lg"
                                    v-model="reportChecked.rewards.c3"
                                    :disabled="selectedPriority !== 'Rewards & Recognition'"
                                >
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.rewards.c3'].some(r=> [
                                          'assessmentForm.rewards.c3.q2',
                                          'assessmentForm.rewards.c3.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.rewards.c3'].includes('assessmentForm.rewards.c3.q1')"
                                      value="q1"><span>Incremental milestone ceremonies</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.rewards.c3'].some(r=> [
                                          'assessmentForm.rewards.c3.q1',
                                          'assessmentForm.rewards.c3.q3',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.rewards.c3'].includes('assessmentForm.rewards.c3.q2')"
                                      value="q2">
                                    <span>Master Technician award ceremony</span></b-form-checkbox>
                                  <b-form-checkbox
                                      v-if="this.assessment['assessmentForm.rewards.c3'].some(r=> [
                                          'assessmentForm.rewards.c3.q1',
                                          'assessmentForm.rewards.c3.q2',
                                          'uncheckAll'
                                          ].includes(r)) && !this.assessment['assessmentForm.rewards.c3'].includes('assessmentForm.rewards.c3.q3')"
                                      value="q3"><span>Tenure trips</span></b-form-checkbox>
                                </b-form-checkbox-group>
                              </report-column>
                            </div>
                        </b-card-text>
                    </b-tab>
                </b-tabs>
<!--            </mq-layout>-->
            </div>
<!--            <mq-layout :mq="['sm', 'md']">-->
<!--                <div class="accordion" role="tablist" ref="test">-->
<!--                    <b-card no-body class="mb-2">-->
<!--                        <b-card-header v-b-toggle.accordion-1 header-tag="header" class="p-1" role="tab">-->
<!--                            <span v-show="selectedPriority === 'Compensation'" class="selected-priority">Selected Priority</span>-->
<!--                            <span>Compensation</span>-->
<!--                        </b-card-header>-->
<!--                        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">-->
<!--                            <b-card-body>-->
<!--                                <div>-->
<!--                                    <span class="slide-count">slide 1 of 3</span>-->
<!--                                    <div class="slide-info-container">-->
<!--                                        <b-button class="slide-button" @click="prev($event)"><font-awesome-icon class="fa-fw" :icon="['fal', 'chevron-left']" /></b-button>-->
<!--                                        <div class="slide-info">-->
<!--                                            <span class="slide-title">ANNUAL INCOME</span>-->
<!--                                        </div>-->
<!--                                        <b-button class="slide-button" @click="next()"><font-awesome-icon class="fa-fw" :icon="['fal', 'chevron-right']" /></b-button>-->
<!--                                    </div>-->
<!--                                    <b-carousel-->
<!--                                            id="carousel-fade"-->
<!--                                            :interval="0"-->
<!--                                            controls-->
<!--                                            data-ref="myCarousel"-->
<!--                                            ref="myCarousel"-->
<!--                                    >-->
<!--                                        <b-carousel-slide>-->
<!--                                            <div class="mt-4">-->
<!--                                                <div class="priority-details">-->
<!--                                                    <div class="priority-details-section mb-5">-->
<!--                                                        <h6>Rating</h6>-->
<!--                                                        <div class="priority-rating">-->
<!--                                                            <span class="priority-rating-text">Good</span>-->
<!--                                                        </div>-->
<!--                                                    </div>-->
<!--                                                    <div class="priority-details-section mb-5">-->
<!--                                                        <h6>Priority for improvement</h6>-->
<!--                                                        <div class="priority-improvement">-->
<!--                                                            <span class="priority-improvement-level">High Priority</span>-->
<!--                                                            <p class="priority-improvement-text mt-4">-->
<!--                                                                Your Dealership has some starter practices in place for improving technician retention in this category.-->
<!--                                                            </p>-->
<!--                                                        </div>-->
<!--                                                    </div>-->
<!--                                                    <div class="priority-details-section mb-5">-->
<!--                                                        <h6>Practices you should implement</h6>-->
<!--                                                        <div class="priority-practices">-->
<!--                                                            <b-form-group>-->
<!--                                                                <b-form-checkbox-group-->
<!--                                                                        name="compensation-priorities"-->
<!--                                                                        stacked-->
<!--                                                                        plain-->
<!--                                                                >-->
<!--                                                                    <b-form-checkbox value="cp1"><span>Take a pulse of technician pay satisfaction</span></b-form-checkbox>-->
<!--                                                                    <b-form-checkbox value="cp2"><span>Conduct a Business Case to assess trade-off costs of raises</span></b-form-checkbox>-->
<!--                                                                </b-form-checkbox-group>-->
<!--                                                            </b-form-group>-->
<!--                                                        </div>-->
<!--                                                    </div>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </b-carousel-slide>-->
<!--                                        <b-carousel-slide>-->
<!--                                            <div class="mt-4">-->
<!--                                                <div class="priority-details">-->
<!--                                                    <div class="priority-details-section mb-5">-->
<!--                                                        <h6>Rating</h6>-->
<!--                                                        <div class="priority-rating deficient">-->
<!--                                                            <span class="priority-rating-text">Deficient</span>-->
<!--                                                        </div>-->
<!--                                                    </div>-->
<!--                                                    <div class="priority-details-section mb-5">-->
<!--                                                        <h6>Priority for improvement</h6>-->
<!--                                                        <div class="priority-improvement">-->
<!--                                                            <span class="priority-improvement-level">Highest Priority</span>-->
<!--                                                            <p class="priority-improvement-text mt-4">-->
<!--                                                                Your Dealership has no practices in place for improving technician retention in this category.-->
<!--                                                            </p>-->
<!--                                                        </div>-->
<!--                                                    </div>-->
<!--                                                    <div class="priority-details-section mb-5">-->
<!--                                                        <h6>Practices you should implement</h6>-->
<!--                                                        <div class="priority-practices">-->
<!--                                                            <b-form-group>-->
<!--                                                                <b-form-checkbox-group-->
<!--                                                                        name="compensation-priorities"-->
<!--                                                                        stacked-->
<!--                                                                        plain-->
<!--                                                                >-->
<!--                                                                    <b-form-checkbox value="cp1"><span>Guaranteed minimums for apprentices or new hires and production bonuses</span></b-form-checkbox>-->
<!--                                                                    <b-form-checkbox value="cp2"><span>120% hours on Warranty repairs</span></b-form-checkbox>-->
<!--                                                                    <b-form-checkbox value="cp3"><span>Hourly Bank</span></b-form-checkbox>-->
<!--                                                                </b-form-checkbox-group>-->
<!--                                                            </b-form-group>-->
<!--                                                        </div>-->
<!--                                                    </div>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </b-carousel-slide>-->
<!--                                        <b-carousel-slide>-->
<!--                                            <div class="mt-4">-->
<!--                                                <div class="priority-details">-->
<!--                                                    <div class="priority-details-section mb-5">-->
<!--                                                        <h6>Rating</h6>-->
<!--                                                        <div class="priority-rating best">-->
<!--                                                            <span class="priority-rating-text">Best</span>-->
<!--                                                        </div>-->
<!--                                                    </div>-->
<!--                                                    <div class="priority-details-section mb-5">-->
<!--                                                        <h6>Priority for improvement</h6>-->
<!--                                                        <div class="priority-improvement">-->
<!--                                                            <span class="priority-improvement-level">No Actions Needed</span>-->
<!--                                                            <p class="priority-improvement-text mt-4">-->
<!--                                                                Congratulations. Your Dealership has best practices in place for improving technician retention in this category.-->
<!--                                                            </p>-->
<!--                                                        </div>-->
<!--                                                    </div>-->
<!--                                                    <div class="priority-details-section mb-5">-->
<!--                                                        <h6>Practices you should implement</h6>-->
<!--                                                        <div class="priority-practices">-->

<!--                                                        </div>-->
<!--                                                    </div>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </b-carousel-slide>-->
<!--                                    </b-carousel>-->
<!--                                </div>-->
<!--                            </b-card-body>-->
<!--                        </b-collapse>-->
<!--                    </b-card>-->

<!--                    <b-card no-body class="mb-2">-->
<!--                        <b-card-header v-b-toggle.accordion-2 header-tag="header" class="p-1" role="tab">-->
<!--                            <span v-show="selectedPriority === 'Training'" class="selected-priority">Selected Priority</span>-->
<!--                            <span>Training</span>-->
<!--                        </b-card-header>-->
<!--                        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">-->
<!--                            <b-card-body>-->
<!--                                <b-card-text>text</b-card-text>-->
<!--                            </b-card-body>-->
<!--                        </b-collapse>-->
<!--                    </b-card>-->

<!--                    <b-card no-body class="mb-2">-->
<!--                        <b-card-header v-b-toggle.accordion-3 header-tag="header" class="p-1" role="tab">-->
<!--                            <span v-show="selectedPriority === 'Management'" class="selected-priority">Selected Priority</span>-->
<!--                            <span>Management</span>-->
<!--                        </b-card-header>-->
<!--                        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">-->
<!--                            <b-card-body>-->
<!--                                <b-card-text>text</b-card-text>-->
<!--                            </b-card-body>-->
<!--                        </b-collapse>-->
<!--                    </b-card>-->

<!--                    <b-card no-body class="mb-2">-->
<!--                        <b-card-header v-b-toggle.accordion-4 header-tag="header" class="p-1" role="tab">-->
<!--                            <span v-show="selectedPriority === 'Dealer Conditions'" class="selected-priority">Selected Priority</span>-->
<!--                            <span>Dealer Conditions</span>-->
<!--                        </b-card-header>-->
<!--                        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">-->
<!--                            <b-card-body>-->
<!--                                <b-card-text>text</b-card-text>-->
<!--                            </b-card-body>-->
<!--                        </b-collapse>-->
<!--                    </b-card>-->

<!--                    <b-card no-body class="mb-2">-->
<!--                        <b-card-header v-b-toggle.accordion-5 header-tag="header" class="p-1" role="tab">-->
<!--                            <span v-show="selectedPriority === 'Rewards & Recognition'" class="selected-priority">Selected Priority</span>-->
<!--                            <span>Rewards & Recognition</span>-->
<!--                        </b-card-header>-->
<!--                        <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">-->
<!--                            <b-card-body>-->
<!--                                <b-card-text>text</b-card-text>-->
<!--                            </b-card-body>-->
<!--                        </b-collapse>-->
<!--                    </b-card>-->
<!--                </div>-->
<!--            </mq-layout>-->
        </div>
    </div>
</template>

<script>
import ReportColumn from "@/components/ReportColumn";
import { mapState, mapMutations } from 'vuex';
import ApiService from "../services/api.service";
    export default {
        name: "Report",
        data() {
            return {
              recentAssessment: null,
                selectedPriority: '',
                selected: [],
                ready: false,
                priority: [
                    'Compensation',
                    'Training',
                    'Management',
                    'Dealer Conditions',
                    'Rewards & Recognition',
                ],
                assessment: null,
                reportChecked: {
                  compensation: {
                    c1: [],
                    c2: [],
                    c3: [],
                  },
                  training: {
                    c1: [],
                    c2: [],
                    c3: [],
                    c4: [],
                  },
                  management: {
                    c1: [],
                    c2: [],
                    c3: [],
                  },
                  dealerConditions: {
                    c1: [],
                    c2: [],
                    c3: [],
                    c4: [],
                  },
                  rewards: {
                    c1: [],
                    c2: [],
                    c3: [],
                  },
                }
            }
        },
        components: {ReportColumn},
        created() {
          // let priority = localStorage.getItem('priority');
          // if (priority == 'null') {
          //   this.selectedPriority = '';
          // } else {
          //   this.selectedPriority = priority;
          // }
          this.getRecentAssessment()
          .then((data) => {
            this.recentAssessment = data.data[0];
            this.selectedPriority = data.data[0].priority;
            localStorage.setItem('priority', this.selectedPriority);
            localStorage.setItem('reportCheckboxes', JSON.stringify(this.recentAssessment.priority_checkboxes))

            this.loadAssessmentFromLocalStorage();

            this.$nextTick(() => {
              this.loadPreviousSelections();
              this.ready = true;
            })
          });
        },
        computed: {
          ...mapState(['currentPriority', 'currentDealership']),
        },
        methods: {
          ...mapMutations(['setCurrentPriority', 'setCurrentAssessment']),
          getRecentAssessment() {
            const params = {
              'query[s]': 'updated_at desc',
              'query[dealership_eq]': this.currentDealership.name.replace('\'', ''),
              per_page: 1
            };
            return ApiService.query('api/v1/assessments', { params });
          },
          getAssessments() {
            const params = {
              'query[s]': 'updated_at desc',
              'query[dealership_eq]': this.currentDealership.name.replace('\'', ''),
            }
            return ApiService.query('api/v1/assessments', { params });
          },
          submitForm() {
            const params = {
              assessment: {
                priority: this.selectedPriority,
                priority_checkboxes: JSON.parse(localStorage.getItem('reportCheckboxes'))
              }
            };
            ApiService.update('api/v1/assessments', this.recentAssessment.id, params)
              .then(({ data }) => {
                this.recentAssessment = data;
                this.setCurrentAssessment(this.recentAssessment);

                this.getAssessments().then((data) => {
                  this.assessments = data.data;
                })

                this.$router.push({ name: 'Plan' });
              })
          },
          canSubmit() {
            if (!this.selectedPriority) return false

            let checkboxChecked = false;

            Object.keys(this.reportChecked).forEach((benchmark) => {
              Object.keys(this.reportChecked[benchmark]).forEach((column) => {
                if (this.reportChecked[benchmark][column].length > 0) {
                  checkboxChecked = true
                }
              })
            });
            return checkboxChecked;
          },
          loadPreviousSelections() {
            var reportChecks = JSON.parse(localStorage.getItem('reportCheckboxes'))

            if (reportChecks == null) return

            this.reportChecked = reportChecks;
          },
          contains(target, pattern) {
            var value = 0;
            pattern.forEach(function(word){
              value = value + target.includes(word);
            });
            return (value === 1)
          },
            ratingFromAssessment(column) {
              if (this.assessment[column].length === 0 || (this.assessment[column].length === 1 && this.assessment[column][0] === "uncheckAll")) {
                return "deficient"
              } else if (this.assessment[column].length === 1) {
                return "good"
              } else if (this.assessment[column].length === 2) {
                return "better"
            } else if (this.assessment[column].length === 3) {
                return "best"
              }
            },
            loadAssessmentFromLocalStorage() {
              this.assessment = JSON.parse(localStorage.getItem('assessmentForm'))
            },
            onChange() {
                const noneChecked = document.querySelector('.deficient input[type="checkbox"]');
                const checks = document.querySelectorAll('.any input[type="checkbox"]');
                if(noneChecked.checked) {
                    for (let i = 0; i < checks.length; i++) {
                        if(checks[i].checked) {
                            checks[i].click();
                        }
                    }
                }
                for (let g = 0; g < checks.length; g++) {
                    if(checks[g].checked && noneChecked.checked) {
                        noneChecked.click();
                    }
                }

            },
            prev(event) {
                console.log(event.target.parentNode.nextSibling.getAttribute("data-ref"));

                this.$refs.myCarousel.prev()
            },
            next() {
                this.$refs.myCarousel.next()
            }
        },
        watch: {
          selected: {
            handler: function(newValue){
              console.log("Selection", newValue)
            }
          },
          selectedPriority: {
            handler: function(newValue){
              var oldPriority = localStorage.getItem('priority');
              localStorage.setItem('priority', newValue);
              this.setCurrentPriority(newValue);


              if (newValue !== oldPriority) {
                this.reportChecked = {
                  compensation: {
                    c1: [],
                    c2: [],
                    c3: [],
                  },
                  training: {
                    c1: [],
                    c2: [],
                    c3: [],
                    c4: [],
                  },
                  management: {
                    c1: [],
                    c2: [],
                    c3: [],
                  },
                  dealerConditions: {
                    c1: [],
                    c2: [],
                    c3: [],
                    c4: [],
                  },
                  rewards: {
                    c1: [],
                    c2: [],
                    c3: [],
                  },
                }
              }

              if (this.recentAssessment) {
                const params = {
                  assessment: {
                    priority: this.selectedPriority,
                  }
                };
                ApiService.update('api/v1/assessments', this.recentAssessment.id, params)
                  .then(({ data }) => {
                    this.recentAssessment = data;
                  })
              }


            }
          },
          reportChecked: {
            handler: function(newValue){
              console.log("new report checked", newValue)
              if (this.recentAssessment) {
                localStorage.setItem('reportCheckboxes', JSON.stringify(newValue));
                const params = {
                  assessment: {
                    priority_checkboxes: newValue,
                  }
                };
                ApiService.update('api/v1/assessments', this.recentAssessment.id, params)
                  .then(({ data }) => {
                    this.recentAssessment = data;
                    this.ready = true;
                  })
              }
            },
            deep: true
          }
        },
    }
</script>

<style lang="scss" scoped>

.action-plan-btn {
  font-family: FordAntennaCond-Regular, sans-serif;
  background-color: $fordBlue;
  box-shadow: 0 20px 20px 0 rgba(0, 0, 0, 0.1),
  0 10px 10px 0 rgba(0, 0, 0, 0.1);
  font-size: 18px;
  height: 40px;
  display: flex;
  min-width: 280px;
  align-items: center;
  justify-content: center;
  text-align: center;
  @media (max-width: 576px) {
    min-width: 240px;
  }

  &:hover {
    background-color: #2861a4;
  }

  svg {
    padding-left: 15px;
    font-size: 20px;

    path {
      fill: #fff;
    }
  }
  &.disabled {
    &:hover {
      text-decoration: none !important;
      background-color: $fordBlue;
      cursor: not-allowed;
    }
  }
}

// TODO: Find a sane place to put this, it used to only work in Chrome.
.selected-priority {
  background-color: $fordBlue;
  font-family: FordAntennaCond-Regular, sans-serif;
  color: #fff;
  width: 100.5%;
  height: 20px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: -0.25%;
  cursor: default;
  border-radius: 8px 8px 0 0;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: .75px;
}

    #report {

      @media (max-width: 1100px) {
        padding-left: 5px;
        padding-right: 5px;
      }

        padding: 25px 30px;
        .select-priority {
            p {
                letter-spacing: .88px;
            }
            .select-priority-heading {
                font-family: FordAntennaCond-Regular, sans-serif;
                text-transform: uppercase;
                color: $fordBlue;
            }
            .download-assessment {
                font-family: FordAntennaCond-Regular, sans-serif;
                color: $fordBlue;
                text-decoration: underline;
                svg {
                    padding-right: 5px;
                    path {
                        fill: $fordBlue;
                    }
                }
            }
            /deep/ .dealership-priority {
                @extend .custom-dropdown;
                width: 265px;
                .vs__dropdown-toggle {
                    background: #fff;
                }
                .vs__dropdown-menu {
                    .vs__dropdown-option {
                        padding: 8px 20px;
                    }
                }
            }
        }

        /deep/ .tabs {
            .tab-column-heading {
                min-height: 60px;
                @extend .tab-heading;
                font-size: 25px;
                font-family: FordAntennaCond-Light, sans-serif;
            }
            .nav-tabs {
                /*z-index: 2;*/
                /*position: relative;*/
                .nav-link {
                    .selected-priority {
                        background-color: $fordBlue;
                        font-family: FordAntennaCond-Regular, sans-serif;
                        color: #fff;
                        width: 100.5%;
                        height: 20px;
                        position: absolute;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        top: 0;
                        left: -0.25%;
                        cursor: default;
                        border-radius: 8px 8px 0 0;
                        text-transform: uppercase;
                        font-size: 12px;
                        letter-spacing: .75px;
                    }
                }
            }
        }
        .priority-details {
            .priority-details-section {
                h6 {
                    font-family: FordAntennaCond-Regular, sans-serif;
                    letter-spacing: 0;
                    color: #4a6579;
                }
                .priority-rating {
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    padding: 8px 30px;
                    height: 42px;
                    background-color: $fordBlue;
                    color: #fff;
                    &.deficient {
                        span:before {
                            content: "\f00d";
                            font-weight: 300;
                            font-family: 'Font Awesome 5 Pro', sans-serif;
                            padding-right: 10px;
                        }
                    }
                    &.better {
                        span:before {
                            content: "\f00c";
                            font-weight: 300;
                            font-family: 'Font Awesome 5 Pro', sans-serif;
                            padding-right: 10px;
                        }
                    }
                    &.best {
                        span:before {
                            content: "\f2f7";
                            font-weight: 300;
                            font-family: 'Font Awesome 5 Pro', sans-serif;
                            padding-right: 10px;
                        }
                    }
                    .priority-rating-text {
                        text-transform: uppercase;
                        color: #fff;
                        font-family: FordAntennaCond-Regular, sans-serif;
                        font-size: 22px;
                        font-weight: 500;
                        letter-spacing: 0;
                    }
                }
                .priority-improvement {
                    .priority-improvement-level {
                        font-family: FordAntennaCond-Regular, sans-serif;
                        text-transform: uppercase;
                        letter-spacing: 1px;
                        color: $fordBlue;
                        font-size: 1rem;
                    }
                    .priority-improvement-text {
                        font-family: FordAntennaCond-Regular, sans-serif;
                        letter-spacing: .88px;
                        margin-bottom: 0;
                    }
                }
                .priority-practices {
                    /deep/ .form-group {
                        padding-left: 5px;
                        /deep/.form-check {
                            &:not(:last-of-type) {
                                margin-bottom: 10px;
                            }
                            .form-check-label {
                                span {
                                    font-family: FordAntennaCond-Regular, sans-serif;
                                }
                            }
                            input[type="checkbox"] {
                                appearance:none;
                                width: 15px;
                                height: 15px;
                                border: 1px solid #8b8c8c;
                                border-radius: 2px;
                                &:checked {
                                    background: #fff;
                                    border-color: $fordBlue;
                                    &:before {
                                        content: "\f14a";
                                        position: absolute;
                                        top: -6px;
                                        font-size: 15px;
                                        font-weight: 900;
                                        left: 0;
                                        font-family: 'Font Awesome 5 Free', sans-serif;
                                        color: $fordBlue;
                                    }
                                }

                            }
                        }
                    }
                }
            }
        }
        .accordion {
            .card-header {
                .selected-priority {
                    background-color: #102b4e;
                    font-family: FordAntennaCond-Regular, sans-serif;
                    color: #fff;
                    width: 100.5%;
                    height: 18px;
                    position: absolute;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    top: 0;
                    left: -0.25%;
                    cursor: default;
                    /*border-radius: 8px 8px 0 0;*/
                    text-transform: uppercase;
                    font-size: 12px;
                    letter-spacing: .75px;
                }
              span {
                  &:not(.selected-priority) {
                    height: 100%;
                    letter-spacing: .88px;
                  }
              }
            }
        }
    }

    // Hide disabled checkboxes on this page only
    /deep/ .custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
      visibility: hidden;
    }
</style>
